import { createAction } from "redux-actions";

import { moduleSlug } from "../constants";

export const clearCredentialsTypes = createAction(`${moduleSlug}/CLEAR_CREDENTIALS_TYPES`);

export const getCredentialsTypes = createAction(`${moduleSlug}/GET_CREDENTIALS_TYPES`);
export const getCredentialsTypesSuccess = createAction(`${moduleSlug}/GET_CREDENTIALS_TYPES/SUCCESS`);
export const getCredentialsTypesError = createAction(`${moduleSlug}/GET_CREDENTIALS_TYPES/ERROR`);

export const deleteCredentialsTypes = createAction(`${moduleSlug}/DELETE_CREDENTIALS_TYPES`);

export const setCredentialsTypesManagerDialog = createAction(`${moduleSlug}/SET_CREDENTIAL_MANAGER_DIALOG`);
export const mergeCredentialsTypesManagerDialog = createAction(`${moduleSlug}/MERGE_CREDENTIAL_MANAGER_DIALOG`);
export const createCredentialsTypes = createAction(`${moduleSlug}/CREATE_CREDENTIALS_TYPES`);
export const editCredentialsTypes = createAction(`${moduleSlug}/EDIT_CREDENTIALS_TYPES`);
